import type { PlayEvent, PlayKind } from "../core/history";

/**
 * История прослушиваний в localStorage.
 *
 * Здесь же и обратная связь, которой не было: пропуск — единственный честный
 * сигнал «не то». У оригинала голосование ни на что не влияло (дефект 7 из
 * разбора); здесь каждое событие сразу меняет следующий подбор.
 *
 * Ничего никуда не отправляется: история остаётся в браузере.
 */
const KEY = "pw.plays";

/**
 * Потолок записей. Четыреста событий это около 18 КБ — заметно меньше любой
 * разумной квоты, и хватает на месяцы: при полураспаде в десять дней всё, что
 * старше, всё равно почти ничего не весит.
 */
const MAX = 400;

let memory: PlayEvent[] | null = null;

function read(): PlayEvent[] {
  if (memory) return memory;
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    memory = Array.isArray(parsed)
      ? parsed.filter((e): e is PlayEvent =>
          typeof e?.id === "string" && typeof e?.at === "number" &&
          (e.kind === "played" || e.kind === "sampled" || e.kind === "skipped"))
      // Записи, сделанные до появления поля `artist`, остаются валидными:
      // они просто не участвуют в усталости от артиста.
      : [];
  } catch {
    memory = [];   // приватный режим или испорченная запись
  }
  return memory;
}

export function allPlays(): PlayEvent[] {
  return read();
}

export function recordPlay(id: string, kind: PlayKind, artist?: string, at = Date.now()) {
  if (!id) return;
  const events = read();
  events.push(artist ? { id, at, kind, artist } : { id, at, kind });
  // Режем с начала: старое и так почти ничего не весит после распада.
  if (events.length > MAX) events.splice(0, events.length - MAX);
  try { localStorage.setItem(KEY, JSON.stringify(events)); }
  catch { /* квота или приватный режим — история живёт до конца вкладки */ }
}
